export const FILIAL_TREE_ACTIONS = {
    TOGGLE_FOLDERS: "FILIAL | TREE | TOGGLE_FOLDERS",

    FOUND_FILIAL: "FILIAL | TREE | FOUND_FILIAL",
}
